import {
  IllustrationStyleDictionary,
  IllustrationStyleKey,
} from '@varo/graphql-schema-types';
import { Maybe } from 'shared/utils/types';

import { IllustrationKeyType } from './Illustration';

export const illustrationKeyForStyleDictionary = (
  styleDictionary: IllustrationStyleDictionary,
): Maybe<IllustrationKeyType> => {
  const { illustrationKey } = styleDictionary;
  switch (illustrationKey) {
    case IllustrationStyleKey.BillsAStaticSquare:
      return 'BILLS_A';
    case IllustrationStyleKey.CalenderAStaticSquare:
      return 'CALENDAR_A';
    case IllustrationStyleKey.CardCStaticSquare:
      return 'CARD_B';
    case IllustrationStyleKey.GaugeDStaticSquare:
      return 'GAUGE_D';
    case IllustrationStyleKey.PaycheckAStaticSquare:
      return 'PAYCHECK_A';
    default:
      return null;
  }
};
